/**
 * Documents sonner behavior for ERP Accelerator.
 */

"use client"

import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-white !text-gray-900 !border !border-gray-200 !shadow-md !rounded-lg",
          title: "!text-gray-900 !font-semibold !text-sm",
          description: "!text-gray-700 !text-sm",
          actionButton:
            "!bg-gray-900 !text-white",
          cancelButton:
            "!bg-gray-100 !text-gray-700",
          closeButton:
            "!bg-white !text-gray-400 hover:!text-gray-600 !border-gray-200",
          success: "!bg-white !text-gray-900 !border-gray-200",
          error: "!bg-white !text-gray-900 !border-gray-200",
          warning: "!bg-white !text-gray-900 !border-gray-200",
          info: "!bg-white !text-gray-900 !border-gray-200",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
